<template>
    <div class="pagoContainer">
        <div v-if="!pagoCompletado">
            <div>
                <div class="form-group">
                    <label class="mb-2 fw-bold">Ingrese monto a pagar {{moneda}} :</label>
                    <input type="tel" class="form-control" v-model="montoApagar" :readonly="bloquearmonto">
                </div>
            </div>
            <div v-if="tipo === 'tarjeta'">
                <div v-if="pagoAppInfoResultCode !== '00'">
                    <div class="mt-2">
                        <div class="mb-2 fw-bold">VisaCuotas:</div>
                        <select v-model="visacuotas" class="form-control">
                            <option value="00">Sin VisaCuotas</option>
                            <option :value="item" v-for="item in userInfo.c">{{item}} VisaCuotas</option>
                        </select>
                    </div>
                    <div class="mt-3 reporte-btns-container">
                        <div v-if="isOnApp" class="btn__reporte">
                            <button @click="comenzarPagoPos" class="btn item-reporte">Pagar en POS</button>
                        </div>
                        <div v-if="!isOnApp" class="btn__reporte">
                            <button @click="comenzarPagoManual" class="btn item-reporte">Pago manual</button>
                        </div>
                    </div>
                    <div v-if="pagoTarjetaManual" class="mt-3">
                        <div class="row">
                            <div class="col-12">
                                <label class="fw-bold">No.Tarjeta</label>
                                <input type="tel" class="form-control" v-model="cardNumber" @keypress="isNumber($event)" maxlength="19">
                            </div>
                            <div class="col-12 mt-2">
                                <label class="fw-bold">Nombre</label>
                                <input type="text" class="form-control" v-model="cardName" @keypress="isLetters($event)">
                            </div>
                            <div class="col-12 mt-2">
                                <label class="fw-bold">Expiración</label>
                                <select class="form-control" :id="cardMonth" v-model="cardMonth" data-card-field>
                                    <option value disabled selected>Mes</option>
                                    <option v-bind:value="n < 10 ? '0' + n : n" v-for="n in 12" v-bind:disabled="n < minCardMonth" v-bind:key="n">{{ generateMonthValue(n) }}</option>
                                </select>
                                <select class="form-control mt-2" :id="cardYear" v-model="cardYear" data-card-field>
                                    <option value disabled selected>Año</option>
                                    <option v-bind:value="$index + minCardYear" v-for="(n, $index) in 12" v-bind:key="n">{{ $index + minCardYear }}</option>
                                </select>
                            </div>
                            <div class="text-right d-flex gap-2 flex-wrap justify-content-end">
                                <div @click="logPago" class="btn btn__crear w-100">
                                    Realizar pago
                                </div>
                            </div>   
                        </div>
                    </div>
                    <div v-if="tipo === 'tarjeta' && listenerTarjeta">
                        <div class="text-primary mt-3 mb-3 font-weight-bold text-center">
                            Esperando App Visanet
                            <div class="mt-3">
                                <img src="assets/images/creditcard/loading.gif" alt="" height="40">
                            </div>
                        </div>
                        <!--<div class="aproxCard">
                            <div class="row aproxCardContainer">
                                <div class="col-4">
                                    <img src="assets/images/creditcard/credit-card-contactless_hires.png" alt="" height="30">
                                    <div>
                                        Aproxima
                                    </div>
                                </div>
                                <div class="col-4">
                                    <img src="assets/images/creditcard/insert-credit-card_hires.png" alt="" height="30">
                                    <div>
                                        Inserta
                                    </div>
                                </div>
                                <div class="col-4">
                                    <img src="assets/images/creditcard/card-in-use_hires.png" alt="" height="30">
                                    <div>
                                        Desliza
                                    </div>
                                </div>
                            </div>
                        </div>-->
                    </div>
                </div>
                <!--<div v-else>
                    <div class="row">
                        <div class="col-12 pr-1">
                            <button @click="logPago({})" class="btn btn-outline-info w-100">Aplicar pago en ACSEL</button>
                        </div>
                    </div>
                </div>-->
            </div>
            <div v-if="tipo === 'efectivo'">
                <div v-if="!makingPago">
                    <div>
                        El item se marcará como pagado, ¿desea continuar?
                    </div>
                    <div @click="logPago" class="btn btn__guardar mt-3 w-100">
                        Sí, realizar pago en efectivo
                    </div>
                </div>
            </div>
            <div v-if="tipo === 'cheque'">
                <div class="text-left">
                    <label class="mb-2 text-primary">Ingrese No.Cheque</label>
                    <input class="form-control" v-model="noCheque">
                </div>
                <div class="text-left mt-3">
                    <div class="mb-2 text-primary">Banco:</div>
                    <select v-model="bancoCheque" class="form-control">
                        <option v-for="item in bancos" :value="item.id_entidad_financiera">
                            {{item.nombre_comercial}}
                        </option>
                    </select>
                </div>
                <hr>
                <div v-if="!makingPago">
                    <div class="mt-3">
                        El item se marcará como pagado, ¿desea continuar?
                    </div>
                    <div @click="logPago" class="btn btn__guardar mt-3 w-100">
                        Sí, realizar pago con cheque
                    </div>
                </div>
            </div>
            <div @click="cancelarPago" class="btn btn__anular mt-3 w-100">
                Cancelar pago
            </div>
            <div v-if="pagoResult !== ''" class="py-3 text-center text-secondary">
                {{pagoResult}}
            </div>
        </div>
        <div v-else class="p-2">
            <div>
                <h5>{{pagoResult}}</h5>
            </div>
            <div v-if="tipo === 'tarjeta'" class="mt-3">
                <h6 class="font-weight-bold">Datos de pago:</h6>
                <div>
                    <span class="text-primary">Transacción No.</span>
                    {{pagoCompletadoData.transaccion}}
                    <!--<div v-if="pagoCompletadoData.voucher.datosCobro" class="mt-2">
                        {{pagoCompletadoData.voucher.datosCobro}}
                    </div>-->
                </div>
                <div>
                    <span class="text-primary">Autorización:</span> {{pagoCompletadoData.voucher.datosCobro}}
                </div>
                <!--<h6 class="mt-3 font-weight-bold">Datos de factura:</h6>
                <div><span class="text-primary">Serie:</span> {{pagoCompletadoData.factura.serie}}</div>
                <div><span class="text-primary">Numero:</span> {{pagoCompletadoData.factura.numero}}</div>
                <div><span class="text-primary">Autorización:</span> {{pagoCompletadoData.factura.autorizacion}}</div>-->
            </div>
            <!--<div v-if="typeof pagoCompletadoData.voucher.datosCobro !== 'undefined'" @click="printVoucher" class="btn btn-outline-primary mt-3 w-100">
                Imprimir voucher
            </div>-->

            <div v-if="!isOnApp && typeof pagoCompletadoData.voucher.titulo !== 'undefined'" @click="printVoucher" class="btn btn__imprimir mt-3 w-100"> Imprimir voucher PDF </div>
            <div @click="pagoOk" class="btn btn__guardar mt-3 w-100">
                Continuar
            </div>
        </div>
    </div>
</template>

<script>

import Layout from "../../global/components/Layout";
import API from "src/core/Api";
import Tools from "src/core/Tools";
import Numbro from "numbro";
import dayjs from "dayjs";
import {store} from "src/store";
import AndroidBridge from "src/core/AndroidBridge";
import {CONFIG} from "src/config";
import {mapGetters} from "vuex";

export default {
    props: ['idpago', 'bloquearmonto', 'monto', 'moneda', 'tipo', 'nit', 'nombre', 'direccion', 'facturaRecibo'],
    components: {
        //TimelineChart,
        Layout,
        //Toster,
    },
    data() {
        return {
            userInfo: {},
            isOnApp: false,
            minCardYear: new Date().getFullYear(),
            cardNumber: '',
            cardName: '',
            cardMonth: '',
            cardYear: '',
            cardCvv: '',

            makingPago: false,
            listenerTarjeta: false,
            pagoTarjetaManual: false,
            bancos: {},
            noCheque: '',
            bancoCheque: '',
            visacuotas: 0,
            androidBridge: false,
            pagoCompletado: false,
            montoApagar: 0,

            pagoCompletadoData: {},
            pagoResult: "",

            idLog: 0,
            infoFactura: {},
            infoVoucher: {},
            pagoAppInfoVisanet: "",
            pagoAppInfoResultCode: "",
            auditNumber: "",
        };
    },
    computed: {
        minCardMonth() {
            if (this.cardYear === this.minCardYear) return new Date().getMonth() + 1
            return 1
        },
    },
    watch: {
        montoApagar: function (value) {
            if (parseFloat(value) > parseFloat(this.monto)) {
                this.montoApagar = this.monto;
            }
        }
    },
    mounted() {
        const self = this;
        this.androidBridge = new AndroidBridge();
        this.isOnApp = this.androidBridge.appEnabled();

        window.addEventListener('AndroidBridgeVisanetPayApp', self.AndroidBridgeVisanetPayAppEvent, {once: true});

        //console.log('******** CONFIGURANDO LISTENER WINDOW *********');
        /*window.addEventListener('AndroidBridgeCardRead', function (e) {
            console.log('**** Card reader event ****');

            if (typeof e.detail !== 'undefined') {
                if (parseInt(e.detail.status) === 0) {
                    alert(e.detail.msg);
                    self.cancelarPagoPos();
                }
                else {
                    self.logPago(e.detail);
                }
            }
            else {
                self.pagoTarjetaResult = "No se ha leído la tarjeta, por favor intente de nuevo";
                self.cancelarPagoPos();
            }
        });*/

        API.send('GET', 'catalogo/bancos', null,
            function (response) {
                if (response.status) {
                    self.bancos = (typeof response.data === "object") ? response.data : {};
                }
                else {
                    alert(response.msg);
                }
                store.dispatch('coreHideLoading');
            },
            function () {
                store.dispatch('coreHideLoading');
                alert('Error de conexión, por favor intente de nuevo');
            });

        // monto a pagar
        this.montoApagar = this.monto;
        this.userInfo = this.AuthGetUserInfo();
    },
    destroyed: function() {
        window.removeEventListener('AndroidBridgeVisanetPayApp', this.AndroidBridgeVisanetPayAppEvent);
    },
    methods: {
        ...mapGetters(["AuthGetUserInfo"]),
        Numbro,
        dayjs,
        isNumber: function(evt) {
            if (!/[0-9\s]/.test(evt.key)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        isLetters: function(evt) {
            if (!/[a-zA-Z \s]/.test(evt.key)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        generateMonthValue(n) {
            return n < 10 ? `0${n}` : n
        },
        cancelarPago() {
            this.makingPago = false;
            this.pagoTarjetaManual = false;
            this.listenerTarjeta = false;
            this.androidBridge.CardReaderStop();
            window.addEventListener('AndroidBridgeVisanetPayApp', self.AndroidBridgeVisanetPayAppEvent);
            this.$emit('cerrar-pago');
        },
        pagoOk() {
            const self = this;
            const dataPago = {
                tipo: self.tipo,
                monto: self.montoApagar,
                codigoBanco: self.bancoCheque,
                noCheque: self.noCheque,
                auth: 0,
            };
            this.$emit('pagado', dataPago);
        },
        comenzarPagoManual() {
            //this.cancelarPagoPos();
            this.pagoTarjetaManual = true;
        },
        comenzarPagoPos() {
            this.makingPago = true;
            this.pagoTarjetaManual = false;
            this.listenerTarjeta = true;
            this.auditNumber = Tools.pad(this.idpago.toString(), 7);

            let montoVisa = 0;

            // si no trae decimal
            if (this.montoApagar.toString().indexOf(".") === -1) {
                montoVisa = this.montoApagar + "00";
            }
            else {
                montoVisa = parseFloat(this.montoApagar).toFixed(2);
                montoVisa = montoVisa.toString().replace(".", "")
            }
            this.androidBridge.VisanetPayApp(montoVisa, this.auditNumber, this.visacuotas);

            /*setTimeout(function () {
                const test = { detail: { status: 1, msg: 'Operación realizada', data: '{"response_code":"00","authorization_code":"071016","response_message":"APROBADO","approved":"true","suggested_nit":"FE19","voucher_code":"000013"}'}};
                let loading = new CustomEvent('AndroidBridgeVisanetPayApp',  test);
                window.dispatchEvent(loading);
            }, 2000);*/
        },
        logPago(data) {

            const self = this;

            const dataPago = {
                tipo: self.tipo,
                monto: self.montoApagar,
                codigoBanco: self.bancoCheque,
                noCheque: self.noCheque,
                auth: 0
            };

            //this.makingPago = false;

            const track = (typeof data.track2 !== 'undefined') ? data.track2 : null;

            //console.log('asdfdasfadslkjflkdsaf *********************')
            /*console.log(JSON.stringify({
                idPago: self.idpago,
                pagoAppInfoVisanet: self.pagoAppInfoVisanet,
                auditNumber: self.auditNumber,
                visacuotas: self.visacuotas,
                codigo: self.tipo,
                track: track,
                monto: self.montoApagar,
                codigoBanco: self.bancoCheque,
                noCheque: self.noCheque,
                tarjetaManual: self.pagoTarjetaManual,
                cardNumber: self.cardNumber,
                cardName: self.cardName,
                cardMonth: self.cardMonth,
                cardYear: self.cardYear,
            }));*/

            API.send('POST', 'cobros/pagolog', {
                    idPago: self.idpago,
                    pagoAppInfoVisanet: self.pagoAppInfoVisanet,
                    auditNumber: self.auditNumber,
                    visacuotas: self.visacuotas,
                    codigo: self.tipo,
                    track: track,
                    monto: self.montoApagar,
                    codigoBanco: self.bancoCheque,
                    noCheque: self.noCheque,
                    tarjetaManual: self.pagoTarjetaManual,
                    cardNumber: self.cardNumber,
                    cardName: self.cardName,
                    cardMonth: self.cardMonth,
                    cardYear: self.cardYear,
                    facturaRecibo: self.facturaRecibo
                },
                function (response) {

                    store.dispatch('coreHideLoading');

                    if (typeof response.status !== 'undefined') {
                        if (response.status) {

                            self.pagoCompletado = true;
                            self.pagoResult = response.msg;
                            self.pagoCompletadoData = response.data;
                            self.idLog = (typeof response.data.idLog !== 'undefined') ? response.data.idLog : 0;
                            dataPago.auth = (typeof response.data.auth !== 'undefined') ? response.data.auth : 0;

                            if (self.tipo !== 'tarjeta') {
                                self.$emit('pagado', dataPago);
                            }
                            else {
                                // si es web
                                if (!self.isOnApp) {

                                }
                                else {
                                    self.$emit('pagado', dataPago);
                                    self.cancelarPago();
                                }
                            }
                        }
                        else {
                            alert(response.msg);
                            self.cancelarPago();
                            self.pagoResult = response.msg;
                        }
                    }
                    else {
                        self.cancelarPago();
                        self.pagoResult = "Error al realizar pago, por favor intente de nuevo";
                        //self.cancelarPago();
                    }
                },
                function (response) {
                    store.dispatch('coreHideLoading');
                    console.log(response);
                    alert(response.msg);
                    self.makingPago = false;
                    self.cancelarPago();
                    alert('Error de conexión, por favor intente de nuevo');
                });
        },
        printVoucher() {
            const self =this;
            API.send('POST', 'print/voucher/' + self.idLog, null,
                function (response) {
                    store.dispatch('coreHideLoading');
                    window.open(CONFIG.apiUrl+"/download/docs/" + response.data);
                },
                function () {
                    store.dispatch('coreHideLoading');
                    alert('Error de conexión, por favor intente de nuevo');
                });
            //this.androidBridge.PrintVoucher(this.infoVoucher);
        },
        AndroidBridgeVisanetPayAppEvent (e) {
            const self = this;

            if (!self.makingPago || self.tipo !== 'tarjeta') return;

            console.log("***************** AndroidBridgeVisanetPayApp ***************** ")

            if (typeof e.detail !== 'undefined') {
                if (parseInt(e.detail.status) === 0) {
                    self.cancelarPago();
                    alert(e.detail.msg);
                }
                else {
                    try {
                        //console.log(e.detail.data);
                        const pagoObj = JSON.parse(e.detail.data);
                        if (typeof pagoObj.response_code !== 'undefined') {
                            if (pagoObj.response_code === "00") {
                                self.pagoAppInfoVisanet = e.detail.data;
                                self.pagoAppInfoResultCode = pagoObj.response_code;
                                self.logPago({});
                            }
                            else {
                                self.cancelarPago();
                                alert(pagoObj.response_message);
                            }
                        }
                        else {
                            self.cancelarPago();
                            alert("Error al identificar respuesta - Visanet");
                        }
                    }
                    catch (e) {
                        self.cancelarPago();
                        alert("Error de comunicación con App Visanet");
                    }
                }
            }
            else {
                self.pagoTarjetaResult = "Error al abrir App Visanet";
                self.cancelarPago();
            }
        }
    },
};
</script>
